(function (window) {
  'use strict';

  const emptySelectClass = 'js-select--empty';

  // Adds/removes a class when the empty option is selected, for styling.
  function handleOptionChange(e) {
    const select = e.target;

    if (select.value == '') {
      select.classList.add(emptySelectClass);
    }
    else {
      select.classList.remove(emptySelectClass);
    }
  }

  function init() {
    const selects = document.querySelectorAll('.js-select');

    for (let i = 0; i < selects.length; i++) {
      if (!selects[i].classList.contains('js-component-init')) {
        selects[i].addEventListener('change', handleOptionChange);
        triggerNativeEvent(selects[i], 'change');

        selects[i].classList.add('js-component-init');
      }
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
